import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid } from "@mui/material";
import { api, IListCustomerItem, RequestStatus } from "../../../logic/api";
import propTypes from "prop-types";
import NotchedCard from "../../../components/cards/NotchedCard/NotchedCard";
import EditableField, { EditableFieldTypes } from "../../../components/editable/EditableField/EditableField";
import EditableGroup, { EditableGroupType } from "../../../components/editable/EditableGroup/EditableGroup";
import { SessionContext } from "../../../utility/useSession";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { ProgressView } from "../../../components/notifications/progress/ProgressView";
import TabbedView from "../../../components/lists/TabbedView/TabbedView";
import TabbedViewPage from "../../../components/lists/TabbedView/TabbedViewPage";
import CredentialManager from "../CredentialManager";
import CarParkManager from "../CarParkManager";
import TerminalManager from "../TerminalManager";
import { useTranslation } from "react-i18next";
const CustomerEditorDialog: React.FunctionComponent<{
  customer: IListCustomerItem;
  show: boolean;
  onClose: (didSave: boolean, customer: IListCustomerItem | null) => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  const [customer, setCustomer] = useState(props.customer);

  const saveCustomer = api.hooks.admin.saveCustomer();

  const isLoading =
    saveCustomer.status == RequestStatus.loading;


  useEffect(() => {
    setCustomer(props.customer);
  }, [props.customer]);


  return <Dialog
    maxWidth={isLoading == true ? undefined : "lg"}
    fullWidth={isLoading == true ? false : true}
    open={props.show}
    keepMounted
    onClose={() => props.onClose(false, null)}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >
    {isLoading == false && (
      <DialogTitle id="alert-dialog-slide-title">
        <div style={{ textAlign: "center" }}>
          {t("admin.customerDatabase")}
        </div>
      </DialogTitle>
    )}

    <DialogContent>
      <ErrorDialog err={saveCustomer.err}></ErrorDialog>
      <ProgressView
        showError={false}
        noDelay={true}
        status={saveCustomer.status}
      >
        <div style={{ minHeight: 500 }}>
          <TabbedView animated={false}>
            <TabbedViewPage title={t("menuItems.settings")}>

              <NotchedCard label={t("booking.cards.customer")}>
                <EditableGroup<IListCustomerItem>
                  id="customer"
                  testId="customer-editor-group"
                  editType={EditableGroupType.alwaysEditing}
                  data={customer}
                  onDataChanged={async (data) => {
                    setCustomer(data);
                    return true;
                  }}
                >
                  <Grid container>


                    <EditableField<IListCustomerItem, string>
                      inputType={EditableFieldTypes.text}
                      label={t("input.labels.customerName")}
                      onProvide={(data) => data.name}
                      onChange={(data, value) => data.name = value}
                    />
                    <EditableField<IListCustomerItem, string>
                      inputType={EditableFieldTypes.empty}
                      label={""}
                    />
                    <EditableField<IListCustomerItem, string>
                      inputType={EditableFieldTypes.text}
                      label={t("admin.clientCode")}
                      onProvide={(data) => data.clientCode}
                      onChange={(data, value) => data.clientCode = value}
                    />
                    <EditableField<IListCustomerItem, string>
                      inputType={EditableFieldTypes.empty}
                      label={""}
                    />
                    <EditableField<IListCustomerItem, boolean>
                      inputType={EditableFieldTypes.switch}
                      label={t("mobile.active")}
                      onProvide={(data) => data.active}
                      onChange={(data, value) => data.active = value}
                    />
                  </Grid>
                </EditableGroup>
              </NotchedCard>

            </TabbedViewPage>
            <TabbedViewPage title={t("admin.carparks")}>
              <CarParkManager customerId={customer.id}></CarParkManager>
            </TabbedViewPage>
            <TabbedViewPage title={t("overview.terminals")}>
              <TerminalManager customerId={customer.id}></TerminalManager>
            </TabbedViewPage>
            <TabbedViewPage title={t("settings.users")}>
              <CredentialManager customerId={customer.id}></CredentialManager>
            </TabbedViewPage>
          </TabbedView>
        </div>
      </ProgressView>
    </DialogContent>
    {isLoading == false && (
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose(false, null);
          }}
          color="primary"
        >
          {t("general.close")}
        </Button>
        <Button
          onClick={() => {
            saveCustomer.send(session.current.context, customer, (result) => {
              if (result == true) {
                props.onClose(true, null);
              }
            });

          }}
          color="primary"
        >
          {t("general.save")}
        </Button>
      </DialogActions>
    )}

  </Dialog>;
}

CustomerEditorDialog.propTypes = {
  customer: propTypes.any,
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};

export default CustomerEditorDialog;
